/** ------------------------------------------
 *  Autogenerated by ⛋ Terrazzo. DO NOT EDIT!
 * ------------------------------------------- */
export const PERMUTATIONS = {
  "{\"tzMode\":\".\"}": {
    "color.brand.base":{"$type":"color","$value":{"colorSpace":"srgb","components":[0,0.47843137254901963,0.40784313725490196],"alpha":1,"hex":"#007a68"}},
    "color.brand.hover":{"$type":"color","$value":{"colorSpace":"srgb","components":[0,0.5568627450980392,0.47843137254901963],"alpha":1,"hex":"#008e7a"}},
    "color.brand.lifted":{"$type":"color","$value":{"colorSpace":"srgb","components":[0.12156862745098039,0.6588235294117647,0.5568627450980392],"alpha":1,"hex":"#1fa88e"}},
    "color.brand.patina":{"$type":"color","$value":{"colorSpace":"srgb","components":[0.16470588235294117,0.615686274509804,0.5411764705882353],"alpha":1,"hex":"#2a9d8a"}},
    "color.brand.pressed":{"$type":"color","$value":{"colorSpace":"srgb","components":[0,0.35294117647058826,0.30196078431372547],"alpha":1,"hex":"#005a4d"}},
    "motion.duration.entrance":{"$type":"duration","$value":{"unit":"ms","value":280}},
    "motion.duration.fast":{"$type":"duration","$value":{"unit":"ms","value":150}},
    "motion.duration.instant":{"$type":"duration","$value":{"unit":"ms","value":120}},
    "motion.duration.normal":{"$type":"duration","$value":{"unit":"ms","value":200}},
    "motion.duration.slow":{"$type":"duration","$value":{"unit":"ms","value":250}},
    "motion.easing.drawer":{"$type":"cubicBezier","$value":[0.32,0.72,0,1]},
    "motion.easing.out":{"$type":"cubicBezier","$value":[0.23,1,0.32,1]},
    "motion.easing.spring":{"$type":"cubicBezier","$value":[0.16,1,0.3,1]},
  },
};
const INPUT_DEFAULTS = {"tzMode":"."};
/** Produce a token set from a given input. */
export const resolver = {
  apply(userInput) {
    if (!userInput || typeof userInput !== "object") {
      throw new Error(`invalid input: ${userInput}`);
    }
    const input = { ...INPUT_DEFAULTS, ...userInput };
    const inputKey = JSON.stringify(Object.fromEntries(Object.entries(input).sort((a, b) => a[0].localeCompare(b[0], "en-us", { numeric: true }))));
    return PERMUTATIONS[inputKey];
  },
  listPermutations() {
    return [{"tzMode":"."}];
  },
};
